import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { BaseRoutes } from "../../../utils/routes";

export function LegacyInvestorOverviewRedirect() {
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const to = search ? `${BaseRoutes.INVESTORS}?${search}` : BaseRoutes.INVESTORS;
  return <Navigate to={to} replace />;
}

export function LegacyInvestorV1Redirect() {
  const { investorId } = useParams();
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const pathname = `${BaseRoutes.INVESTORS}/${investorId}`;
  const to = search ? `${pathname}?${search}` : pathname;
  return <Navigate to={to} replace />;
}

export function LegacyInvestorProfileRedirect() {
  const { investorProfileId } = useParams();
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const pathname = `${BaseRoutes.INVESTOR_PROFILES}/${investorProfileId}`;
  const to = search ? `${pathname}?${search}` : pathname;
  return <Navigate to={to} replace />;
}
